'use client'

import type React from 'react'
import { forwardRef, ReactNode } from 'react'
import styles from './Button.module.scss'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'outline'
    | 'ghost'
    | 'link'
    | 'review_export_button'
    | 'wishlist_help'
    | 'wishlist_explore'
  size?: 'sm' | 'md' | 'lg' | 'ds'
  isLoading?: boolean
  ariaLabel?: string
  onButtonClick?: () => void
  children: ReactNode
  link?: string
  className?: string
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      onButtonClick,
      children,
      variant = '',
      size = 'md',
      isLoading,
      disabled,
      ariaLabel,
      link,
      type,
      ...props
    },
    ref
  ) => {
    const handleButtonClick = () => {
      if (link) {
        window.location.href = link
      }
      if (onButtonClick) {
        onButtonClick()
      }
    }

    return (
      /* eslint-disable react/button-has-type */
      <button
        type={type ?? 'button'}
        className={`${styles.button} ${styles[variant]} ${styles[size]} ${className || ''}`}
        ref={ref}
        disabled={isLoading || disabled}
        onClick={handleButtonClick}
        aria-label={ariaLabel}
        {...props}>
        {isLoading ? <div className={styles.loadingSpinner} /> : null}
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'

export { Button }
